import React from "react";
import { Switch, Route } from "react-router-dom";
import routesConfig from "utils/routesConfig";

import PulseLanding from "./PulseLanding";
import PulseQuestions from "./PulseQuestions";
import PulsePost from "./PulsePost";

const PulsePage: React.FC = () => {
  return (
    <Switch>
      <Route exact path={routesConfig.pulse.landing.path}>
        <PulseLanding />
      </Route>
      <Route path={routesConfig.pulse.questions.path}>
        <PulseQuestions />
      </Route>
      <Route path={routesConfig.pulse.complete.path}>
        <PulsePost />
      </Route>
    </Switch>
  );
};

export default PulsePage;
